import { render, staticRenderFns } from "./android.vue?vue&type=template&id=910372a8&scoped=true&"
import script from "./android.vue?vue&type=script&lang=js&"
export * from "./android.vue?vue&type=script&lang=js&"
import style0 from "./android.vue?vue&type=style&index=0&id=910372a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910372a8",
  null
  
)

export default component.exports